// src/store/addCardSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchApi } from '../../utilities/api';
import { ENDPOINTS } from '../../utilities/endpoints';
interface AddCardParams {
  token: string;
  last4: string;
  brand: string;
  isDefault?: boolean;
}

interface AddCardState {
  isLoading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: AddCardState = {
  isLoading: false,
  error: null,
  success: false,
};

export const addCard = createAsyncThunk<
  void,
  AddCardParams,
  { rejectValue: string }
>(
  'addCard/add',
  async (params, { rejectWithValue }) => {
    try {
      const jwt = localStorage.getItem('token');
      if (!jwt) throw new Error('No auth token found');
      const endpoint = ENDPOINTS.USERS.ADD_PAYMENT_METHOD; 

      await fetchApi<{ success: boolean }>(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${jwt}`,
        },
        body: JSON.stringify(params),
      });
    } catch (err: any) {
      return rejectWithValue(err.message || 'Failed to add card');
    }
  }
);

const addCardSlice = createSlice({
  name: 'addCard',
  initialState,
  reducers: {
    resetAddCardState(state) {
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(addCard.pending, state => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addCard.fulfilled, state => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(addCard.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload ?? action.error.message ?? 'Unknown error';
      });
  },
});

export const { resetAddCardState } = addCardSlice.actions;
export default addCardSlice.reducer;
